import { render, staticRenderFns } from "./ServicesReservationForm.vue?vue&type=template&id=ae553a34&"
import script from "./ServicesReservationForm.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports